import { useEffect } from "react";
import { TransactionColumn } from "@common/types/views/transactionViews";
import { getTransactionsTableMeta } from "@hooks/view/useViewTableMeta";

/**
 * Registers how a memo cell opens for editing, so row and task hotkeys can
 * open it. Pass a stable `open` (memoized with `useCallback`); a new identity
 * re-registers the opener.
 */
export const useRegisterNoteCellOpener = ({
    table,
    rowId,
    open,
}: {
    table: Parameters<typeof getTransactionsTableMeta>[0];
    rowId: number;
    open: () => void;
}) => {
    const { registerCellActionOpener } = getTransactionsTableMeta(table);

    useEffect(() => {
        if (!registerCellActionOpener) {
            return;
        }

        return registerCellActionOpener({
            columnId: TransactionColumn.NOTE,
            rowId,
            open,
        });
    }, [registerCellActionOpener, rowId, open]);
};
